<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
    [fullScreen]="true">
    <span class="loader">
        <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
    </span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg width="28" height="38" viewBox="0 0 28 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_534_1023)">
                            <path d="M8.73438 5.38853H19.3343V3.25956H15.8403V0H12.1576V3.25956H8.73438V5.38853Z"
                                fill="#265D91" />
                            <path
                                d="M23.0071 5.26135H21.1792V6.30811C21.1792 6.81596 20.7664 7.2277 20.2573 7.2277H7.81339C7.30421 7.2277 6.8914 6.81596 6.8914 6.30811V5.26135H4.99288C4.4445 5.26135 4 5.70476 4 6.25165V28.0122C4 28.5592 4.44456 29.0025 4.99288 29.0025H23.0071C23.5555 29.0025 24 28.5591 24 28.0122V6.25165C23.9999 5.70469 23.5554 5.26135 23.0071 5.26135ZM9.66407 24.6577C9.31129 25.0116 8.72134 25.0152 8.36426 24.6654L6.74707 23.0816L8.03906 21.7693L9.00248 22.7128L11.514 20.1933L12.8217 21.49L9.66407 24.6577ZM9.66407 14.8943C9.31129 15.2482 8.7214 15.2518 8.36426 14.9021L6.74707 13.3183L8.03906 12.0059L9.00248 12.9495L11.514 10.4299L12.8217 11.7267L9.66407 14.8943ZM21.4019 26.2713H14.9673V24.4321H21.4019V26.2713ZM21.4019 21.6653H14.9673V19.8261H21.4019V21.6653ZM21.4019 16.3509H14.9673V14.5117H21.4019V16.3509ZM21.4019 11.745H14.9673V9.90579H21.4019V11.745Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_534_1023" x="0" y="0" width="28" height="37.0026"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_534_1023" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_534_1023"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>
                    Evaluation
                </h1>

                <!--begin::Menu-->

            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a routerLink="/accueil" class="text-muted ">Accueil</a>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Evaluation</li>

                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">PVs</li>

                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card header-->

            <div class="card-body tools">
                <div class="title mb-3">
                    <h4>Recherche</h4>
                </div>
                <div [formGroup]="searchForm">
                    <div class="row mb-3">
                        <div class="col-lg-3">
                            <input type="text" name="evaluation_name" id="evaluation"
                                class="form-control form-control-solid mb-3" placeholder="Nom évaluation"
                                formControlName="evaluation_name">
                        </div>

                        <div class="col-lg-3">
                            <input type="text" name="consultant_name" id="consultant"
                                class="form-control form-control-solid mb-3" placeholder="Nom Consultant"
                                formControlName="consultant_name">
                        </div>

                        <div class="col-lg-3">
                            <ng-select [items]="signatureStatuses " bindLabel="name" bindValue="id" id="Signature"
                                [notFoundText]="'Aucun élément trouvé'" class="mb-3" placeholder="État de Signature"
                                formControlName="signature_status">
                            </ng-select>
                        </div>

                        <div class="col-lg-3">
                            <ng-select [items]="type" bindLabel="name" bindValue="id" id="type"
                                formControlName="evaluation_type" class="mb-3" [notFoundText]="'Aucun élément trouvé'"
                                placeholder="Type d’évaluation">
                            </ng-select>
                        </div>

                        <div class="col-lg-3 calenderDate mb-3">
                            <!-- <input type="date" formControlName="start_date" id="date" class="form-control form-control-solid mb-3" placeholder="Date début"> -->
                            <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"
                                placeholder="Date de début" inputId="yearpicker" class="mb-3" formControlName="start_date"
                                class="form-control"></p-calendar>
                        </div>

                        <div class="col-lg-3 calenderDate">
                            <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy"
                                placeholder="Date de fin" inputId="yearpicker" class="mb-3" formControlName="end_date"
                                class="form-control"></p-calendar>
                        </div>
                        <div class="col-lg-3">

                        </div>
                    </div>
                    <div class="row mt-3 d-flex justify-content-end">
                        <div class="col-lg-3 rechercher">

                            <div class="mb-3 search-btn d-flex justify-content-end">
                                <div class="align-items-center btn_search me-2">

                                    <div class="btn_search cursor-pointer">
                                        <a (click)="currentPage = 0; getPvList()" class="search"> <svg width="20"
                                                height="20" viewBox="0 0 20 20" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                                                    fill="white" />
                                            </svg>
                                            Rechercher</a>

                                    </div>
                                </div>
                                <div class="resett-btn">
                                    <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip"
                                        data-bs-placement="top" title="Réinitialiser">
                                        <a (click)="reset()"> <img src="/assets/media/icons/reset.png" alt=""
                                                width="30px"></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--end::Content container-->
</div>

<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card content-table">

            <!--begin::Card header-->
            <div class="d-flex  header-grid align-items-center">
                <div class="section_title">
                    <h1 class="section-heading my-5">Liste des PVs</h1>
                </div>
                <ul class="nav nav-pills me-5">
                    <li class="nav-item m-0">
                        <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3"
                            data-bs-toggle="tab" href="#kt_project_targets_card_pane">
                            <i class="ki-duotone ki-element-plus fs-1">
                                <span class="path1"></span>
                                <span class="path2"></span>
                                <span class="path3"></span>
                                <span class="path4"></span>
                                <span class="path5"></span>
                            </i>
                        </a>
                    </li>
                    <li class="nav-item m-0">
                        <a class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                            data-bs-toggle="tab" href="#kt_project_targets_table_pane">
                            <i class="ki-duotone ki-row-horizontal fs-2">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </a>
                    </li>
                </ul>
            </div>

            <!--end::Card header-->
            <!--begin::Card body-->
            <div class="card-body pt-0 pb-0">
                <div class="tab-content for-web pt-5">
                    <!--begin::Tab pane-->
                    <div id="kt_project_targets_card_pane" class="tab-pane fade ">
                        <div class="card-body">
                            <div class="row g-6 g-xl-9 justify-content-center" *ngIf="pvList?.length">
                                <!--begin::Col-->
                                <div class="col-md-6 col-xxl-4" *ngFor="let pv of pvList">
                                    <!--begin::Card-->
                                    <div class="card pt-5 p-5">
                                        <div class="poste">
    
                                            <span class="badge hybrid">{{pv.evaluation_esn_sent?.type?
                                                pv.evaluation_esn_sent?.type : '---' }}</span>
                                            <span class="tag"
                                                [ngClass]="getSignatureStatusClass(pv)">{{getSignatureStatusLabel(pv)}}</span>
                                        </div>
                                        <div class="card-header flex-nowrap border-0 pt-9">
                                            <div class="card-title m-0">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img class="table-img" src="{{pv.evaluation_esn_sent?.consultant?.image_url ? 
                                                        urlimage + pv.evaluation_esn_sent?.consultant?.image_url : '/assets/media/icons/avatar.jpg'}}" alt=""
                                                        width="50px">
                                                </div>
                                                <div class="esn-name">
                                                    {{pv.evaluation_esn_sent?.consultant?.first_name ?
                                                        pv.evaluation_esn_sent?.consultant?.first_name : '---'}}
                                                        {{pv.evaluation_esn_sent?.consultant?.last_name ?
                                                        pv.evaluation_esn_sent?.consultant?.last_name : '---'}}
                                                </div>
                                                
                                            <span class="name-eval"> {{pv.evaluation_esn_sent?.name ? pv.evaluation_esn_sent?.name
                                                :'---'}}</span>
                                            </div>
                                        </div>
                                        <div class="foot pt-2">
                                            <div class="card-foot">
                                                <div class="report">
                                                    <a (click)="openModalCompteRendu(compte_rendu, pv.report)">
                                                        <svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <g filter="url(#filter0_d_3631_1281)">
                                                                <rect x="8" y="9" width="32.0513" height="32.0513" rx="7"
                                                                    fill="white" />
                                                            </g>
                                                            <path d="M25.9122 17.8911H21.4336V14.9945H25.9122V17.8911Z"
                                                                stroke="#265D91" />
                                                            <path
                                                                d="M27.1954 19.6704H27.6954V19.1704V16.5531H29.152C29.9568 16.5531 30.6087 17.2053 30.6087 18.0014V33.5879C30.6087 34.384 29.9568 35.0362 29.152 35.0362H18.1949C17.3902 35.0362 16.7383 34.384 16.7383 33.5879V18.0014C16.7383 17.2053 17.3902 16.5531 18.1949 16.5531H19.6515V19.1704V19.6704H20.1515H27.1954ZM21.3255 32.1396H26.0214C26.512 32.1396 26.9128 31.7436 26.9128 31.2499C26.9128 30.7563 26.512 30.3603 26.0214 30.3603H21.3255C20.8357 30.3603 20.4342 30.756 20.4342 31.2499C20.4342 31.7439 20.8357 32.1396 21.3255 32.1396ZM19.7602 29.8016H27.5867C28.0773 29.8016 28.4781 29.4056 28.4781 28.912C28.4781 28.4183 28.0773 28.0223 27.5867 28.0223H19.7602C19.2704 28.0223 18.8689 28.418 18.8689 28.912C18.8689 29.4059 19.2704 29.8016 19.7602 29.8016ZM19.7602 27.4636H27.5867C28.0773 27.4636 28.4781 27.0676 28.4781 26.574C28.4781 26.0804 28.0773 25.6843 27.5867 25.6843H19.7602C19.2704 25.6843 18.8689 26.08 18.8689 26.574C18.8689 27.0679 19.2704 27.4636 19.7602 27.4636ZM19.7602 25.1257H27.5867C28.0776 25.1257 28.4781 24.7289 28.4781 24.236C28.4781 23.7431 28.0776 23.3464 27.5867 23.3464H19.7602C19.2701 23.3464 18.8689 23.7428 18.8689 24.236C18.8689 24.7293 19.2701 25.1257 19.7602 25.1257ZM19.7602 22.7877H27.5867C28.0776 22.7877 28.4781 22.391 28.4781 21.8981C28.4781 21.4051 28.0776 21.0084 27.5867 21.0084H19.7602C19.2701 21.0084 18.8689 21.4048 18.8689 21.8981C18.8689 22.3913 19.2701 22.7877 19.7602 22.7877Z"
                                                                stroke="#265D91" />
                                                            <defs>
                                                                <filter id="filter0_d_3631_1281" x="0" y="0" width="52.0508"
                                                                    height="52.0513" filterUnits="userSpaceOnUse"
                                                                    color-interpolation-filters="sRGB">
                                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                                        result="hardAlpha" />
                                                                    <feOffset dx="2" dy="1" />
                                                                    <feGaussianBlur stdDeviation="5" />
                                                                    <feComposite in2="hardAlpha" operator="out" />
                                                                    <feColorMatrix type="matrix"
                                                                        values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.24 0" />
                                                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                                                        result="effect1_dropShadow_3631_1281" />
                                                                    <feBlend mode="normal" in="SourceGraphic"
                                                                        in2="effect1_dropShadow_3631_1281" result="shape" />
                                                                </filter>
                                                            </defs>
                                                        </svg>
                                                    </a>
                                                </div>
                                                <div class="plus">
                                                    <a class="dropdown-item cursor-pointer" (click)="detailPV(pv?.id)">
                                                        {{pv?.status === "2" && pv?.signature_consultant && !pv?.signature_esn ? 'Signer' : 'Visualiser'}}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pagination mt-4" *ngIf="pvList?.length">
                                <mat-paginator [length]="totalElements" [pageSize]="pageSize" [showFirstLastButtons]="true"
                                    [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage"
                                    (page)="onPageChange($event)" aria-label="Select page">
                                </mat-paginator>
                            </div>
                            <app-empty-state *ngIf="!pvList?.length" [title]="parentItem"></app-empty-state>
                        </div>
                        <!--begin::Row-->
                        
                       
                    </div>
                    <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                        <div class="content">
                            <div class="card-body pt-3">
                                <!--begin::Table-->
                                <div class="table-responsive" *ngIf="pvList?.length>0" id="kt_customers_table">
                                    <table class="table align-middle gy-5">
                                        <thead>
                                            <tr class="text-start fw-bold text-uppercase gs-0">
                                                <th class="min-w-110px">Photo</th>
                                                <th class="min-w-110px th-fixed">Nom Consultant</th>
                                                <th class="min-w-110px">Nom evaluation</th>
                                                <th class="min-w-110px">Type</th>
                                                <th class="min-w-110px">État de Signature</th>
                                                <th class="min-w-110px">DATE</th>
                                                <th class="min-w-110px">Compte rendu</th>
                                                <th class="min-w-110px">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody class="fw-semibold text-gray-600">
                                            <tr *ngFor="let pv of pvList">
                                                <td>
                                                    <img class="table-img"
                                                        src="{{pv.evaluation_esn_sent?.consultant?.image_url ? 
                                                                urlimage + pv.evaluation_esn_sent?.consultant?.image_url : '/assets/media/icons/avatar.jpg'}}"
                                                        alt="" width="50px">
                                                </td>
                                                <td>
                                                    <span class="esn-name">
                                                        {{pv.evaluation_esn_sent?.consultant?.first_name ?
                                                        pv.evaluation_esn_sent?.consultant?.first_name : '---'}}
                                                        {{pv.evaluation_esn_sent?.consultant?.last_name ?
                                                        pv.evaluation_esn_sent?.consultant?.last_name : '---'}}
                                                    </span>
                                                </td>
                                                <td class="td-fixed">
                                                    <span class="eval-name">{{pv.evaluation_esn_sent?.name}}</span>
                                                </td>
                                                <td>
                                                    <span class="hybrid" *ngIf="pv.evaluation_esn_sent?.type =='Annuelle'"
                                                        [style.border-color]="'#63C3E8'"
                                                        [style.color]="'#63C3E8'">Annuelle</span>
                                                    <span class="remote" *ngIf="pv.evaluation_esn_sent?.type=='Suivi'"
                                                        [style.border-color]="'#265D91'" [style.color]="'#265D91'">Suivi</span>
                                                    <span class="remote" *ngIf="!pv.evaluation_esn_sent?.type">---</span>
                                                </td>
                                                <td>
                                                    <span class="tag"
                                                        [ngClass]="getSignatureStatusClass(pv)">{{getSignatureStatusLabel(pv)}}</span>
                                                </td>
        
                                                <td>
                                                    <span [ngbTooltip]="getDateTooltip(pv) ? getDateTooltip(pv) : null">
                                                        {{ getDateByStatus(pv) ? ( getDateByStatus(pv) | date:'dd/MM/yyyy') :
                                                        '---' }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <a (click)="openModalCompteRendu(compte_rendu, pv.report)">
                                                        <svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <g filter="url(#filter0_d_3631_1281)">
                                                                <rect x="8" y="9" width="32.0513" height="32.0513" rx="7"
                                                                    fill="white" />
                                                            </g>
                                                            <path d="M25.9122 17.8911H21.4336V14.9945H25.9122V17.8911Z"
                                                                stroke="#265D91" />
                                                            <path
                                                                d="M27.1954 19.6704H27.6954V19.1704V16.5531H29.152C29.9568 16.5531 30.6087 17.2053 30.6087 18.0014V33.5879C30.6087 34.384 29.9568 35.0362 29.152 35.0362H18.1949C17.3902 35.0362 16.7383 34.384 16.7383 33.5879V18.0014C16.7383 17.2053 17.3902 16.5531 18.1949 16.5531H19.6515V19.1704V19.6704H20.1515H27.1954ZM21.3255 32.1396H26.0214C26.512 32.1396 26.9128 31.7436 26.9128 31.2499C26.9128 30.7563 26.512 30.3603 26.0214 30.3603H21.3255C20.8357 30.3603 20.4342 30.756 20.4342 31.2499C20.4342 31.7439 20.8357 32.1396 21.3255 32.1396ZM19.7602 29.8016H27.5867C28.0773 29.8016 28.4781 29.4056 28.4781 28.912C28.4781 28.4183 28.0773 28.0223 27.5867 28.0223H19.7602C19.2704 28.0223 18.8689 28.418 18.8689 28.912C18.8689 29.4059 19.2704 29.8016 19.7602 29.8016ZM19.7602 27.4636H27.5867C28.0773 27.4636 28.4781 27.0676 28.4781 26.574C28.4781 26.0804 28.0773 25.6843 27.5867 25.6843H19.7602C19.2704 25.6843 18.8689 26.08 18.8689 26.574C18.8689 27.0679 19.2704 27.4636 19.7602 27.4636ZM19.7602 25.1257H27.5867C28.0776 25.1257 28.4781 24.7289 28.4781 24.236C28.4781 23.7431 28.0776 23.3464 27.5867 23.3464H19.7602C19.2701 23.3464 18.8689 23.7428 18.8689 24.236C18.8689 24.7293 19.2701 25.1257 19.7602 25.1257ZM19.7602 22.7877H27.5867C28.0776 22.7877 28.4781 22.391 28.4781 21.8981C28.4781 21.4051 28.0776 21.0084 27.5867 21.0084H19.7602C19.2701 21.0084 18.8689 21.4048 18.8689 21.8981C18.8689 22.3913 19.2701 22.7877 19.7602 22.7877Z"
                                                                stroke="#265D91" />
                                                            <defs>
                                                                <filter id="filter0_d_3631_1281" x="0" y="0" width="52.0508"
                                                                    height="52.0513" filterUnits="userSpaceOnUse"
                                                                    color-interpolation-filters="sRGB">
                                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                                        result="hardAlpha" />
                                                                    <feOffset dx="2" dy="1" />
                                                                    <feGaussianBlur stdDeviation="5" />
                                                                    <feComposite in2="hardAlpha" operator="out" />
                                                                    <feColorMatrix type="matrix"
                                                                        values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.24 0" />
                                                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                                                        result="effect1_dropShadow_3631_1281" />
                                                                    <feBlend mode="normal" in="SourceGraphic"
                                                                        in2="effect1_dropShadow_3631_1281" result="shape" />
                                                                </filter>
                                                            </defs>
                                                        </svg>
                                                    </a>
                                                </td>
                                                <td>
                                                    <div class="seemore" (click)="detailPV(pv?.id)">
                                                        <a>{{pv?.signature_consultant && !pv?.signature_esn ? 'Signer' : 'Visualiser'}}</a>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="pagination mt-4" *ngIf="pvList?.length">
                                    <mat-paginator [length]="totalElements" [pageSize]="pageSize" [showFirstLastButtons]="true"
                                        [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage"
                                        (page)="onPageChange($event)" aria-label="Select page">
                                    </mat-paginator>
                                </div>
                                <app-empty-state *ngIf="!pvList?.length" [title]="parentItem"></app-empty-state>
                                
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="tab-content for-mobile">
                    <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                         <div class="card-body">
                            <div class="row g-6 g-xl-9 justify-content-center" *ngIf="pvList?.length">
                                <!--begin::Col-->
                                <div class="col-md-6 col-xxl-4" *ngFor="let pv of pvList">
                                    <!--begin::Card-->
                                    <div class="card pt-5 p-5">
                                        <div class="poste">
    
                                            <span class="badge hybrid">{{pv.evaluation_esn_sent?.type?
                                                pv.evaluation_esn_sent?.type : '---' }}</span>
                                            <span class="tag"
                                                [ngClass]="getSignatureStatusClass(pv)">{{getSignatureStatusLabel(pv)}}</span>
                                        </div>
                                        <div class="card-header flex-nowrap border-0 pt-9">
                                            <div class="card-title m-0">
                                                <!--begin::Avatar-->
                                                <div class="symbol symbol-65px symbol-circle mb-5">
                                                    <img class="table-img" src="{{pv.evaluation_esn_sent?.consultant?.image_url ? 
                                                        urlimage + pv.evaluation_esn_sent?.consultant?.image_url : '/assets/media/icons/avatar.jpg'}}" alt=""
                                                        width="50px">
                                                </div>
                                                <div class="esn-name">
                                                    {{pv.evaluation_esn_sent?.consultant?.first_name ?
                                                        pv.evaluation_esn_sent?.consultant?.first_name : '---'}}
                                                        {{pv.evaluation_esn_sent?.consultant?.last_name ?
                                                        pv.evaluation_esn_sent?.consultant?.last_name : '---'}}
                                                </div>
                                                
                                            <span class="name-eval"> {{pv.evaluation_esn_sent?.name ? pv.evaluation_esn_sent?.name
                                                :'---'}}</span>
                                            </div>
                                        </div>
                                        <div class="foot pt-2">
                                            <div class="card-foot">
                                                <div class="report">
                                                    <a (click)="openModalCompteRendu(compte_rendu, pv.report)">
                                                        <svg width="53" height="53" viewBox="0 0 53 53" fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <g filter="url(#filter0_d_3631_1281)">
                                                                <rect x="8" y="9" width="32.0513" height="32.0513" rx="7"
                                                                    fill="white" />
                                                            </g>
                                                            <path d="M25.9122 17.8911H21.4336V14.9945H25.9122V17.8911Z"
                                                                stroke="#265D91" />
                                                            <path
                                                                d="M27.1954 19.6704H27.6954V19.1704V16.5531H29.152C29.9568 16.5531 30.6087 17.2053 30.6087 18.0014V33.5879C30.6087 34.384 29.9568 35.0362 29.152 35.0362H18.1949C17.3902 35.0362 16.7383 34.384 16.7383 33.5879V18.0014C16.7383 17.2053 17.3902 16.5531 18.1949 16.5531H19.6515V19.1704V19.6704H20.1515H27.1954ZM21.3255 32.1396H26.0214C26.512 32.1396 26.9128 31.7436 26.9128 31.2499C26.9128 30.7563 26.512 30.3603 26.0214 30.3603H21.3255C20.8357 30.3603 20.4342 30.756 20.4342 31.2499C20.4342 31.7439 20.8357 32.1396 21.3255 32.1396ZM19.7602 29.8016H27.5867C28.0773 29.8016 28.4781 29.4056 28.4781 28.912C28.4781 28.4183 28.0773 28.0223 27.5867 28.0223H19.7602C19.2704 28.0223 18.8689 28.418 18.8689 28.912C18.8689 29.4059 19.2704 29.8016 19.7602 29.8016ZM19.7602 27.4636H27.5867C28.0773 27.4636 28.4781 27.0676 28.4781 26.574C28.4781 26.0804 28.0773 25.6843 27.5867 25.6843H19.7602C19.2704 25.6843 18.8689 26.08 18.8689 26.574C18.8689 27.0679 19.2704 27.4636 19.7602 27.4636ZM19.7602 25.1257H27.5867C28.0776 25.1257 28.4781 24.7289 28.4781 24.236C28.4781 23.7431 28.0776 23.3464 27.5867 23.3464H19.7602C19.2701 23.3464 18.8689 23.7428 18.8689 24.236C18.8689 24.7293 19.2701 25.1257 19.7602 25.1257ZM19.7602 22.7877H27.5867C28.0776 22.7877 28.4781 22.391 28.4781 21.8981C28.4781 21.4051 28.0776 21.0084 27.5867 21.0084H19.7602C19.2701 21.0084 18.8689 21.4048 18.8689 21.8981C18.8689 22.3913 19.2701 22.7877 19.7602 22.7877Z"
                                                                stroke="#265D91" />
                                                            <defs>
                                                                <filter id="filter0_d_3631_1281" x="0" y="0" width="52.0508"
                                                                    height="52.0513" filterUnits="userSpaceOnUse"
                                                                    color-interpolation-filters="sRGB">
                                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                                        result="hardAlpha" />
                                                                    <feOffset dx="2" dy="1" />
                                                                    <feGaussianBlur stdDeviation="5" />
                                                                    <feComposite in2="hardAlpha" operator="out" />
                                                                    <feColorMatrix type="matrix"
                                                                        values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.24 0" />
                                                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                                                        result="effect1_dropShadow_3631_1281" />
                                                                    <feBlend mode="normal" in="SourceGraphic"
                                                                        in2="effect1_dropShadow_3631_1281" result="shape" />
                                                                </filter>
                                                            </defs>
                                                        </svg>
                                                    </a>
                                                </div>
                                                <div class="plus">
                                                    <a class="dropdown-item cursor-pointer" (click)="detailPV(pv?.id)">
                                                       {{pv?.status === "2" && pv?.signature_consultant && !pv?.signature_esn ? 'Signer' : 'Visualiser'}}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pagination mt-4" *ngIf="pvList?.length">
                                <mat-paginator [length]="totalElements" [pageSize]="pageSize" [showFirstLastButtons]="true"
                                    [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage"
                                    (page)="onPageChange($event)" aria-label="Select page">
                                </mat-paginator>
                            </div>
                            <app-empty-state *ngIf="!pvList?.length" [title]="parentItem"></app-empty-state>
                        </div>
                    </div>
                 </div>
            </div>
            <!--end::Tab pane-->
            <!--begin::Tab pane-->
         
        </div>

    </div>
    <!--end::Content container-->
</div>


<ng-template #compte_rendu let-modal class="modal-dialog-centered">
    <div class="modal-dialog-centered">
        <div class="modal-content pt-5 pb-15">
            <div class="modal-header">
                <h2 class="fw-bold">Compte rendu</h2>
                <div (click)="closeModal()" id="kt_customers_export_close"
                    class="btn btn-icon btn-sm btn-active-icon-primary">
                    <i class="ki-duotone ki-cross fs-1" data-bs-dismiss="modal">
                        <span class="path1"></span>
                        <span class="path2"></span>
                    </i>
                </div>
            </div>

            <div class="modal-body rendu-compte mx-5 my-7">
                <div class="rendu-warapper">
                    <span [innerHTML]="safeDescription"></span>
                </div>
            </div>
        </div>
    </div>
</ng-template>